/*
  mini-shop-the-look.js  (Hybrid v3)
  Hotspot tooltip logic — desktop + mobile.
  Place in: assets/mini-shop-the-look.js
*/

(function () {
  'use strict';

  var OFFSET = 12; // px gap between pin and tooltip edge

  /* ── Wire every hotspot button ──────────────────────────────────────── */
  document.querySelectorAll('.mstl-hotspot').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();

      var id      = btn.dataset.hotspotId;
      var tooltip = document.getElementById('mstl-tip-' + id);
      if (!tooltip) return;

      var isOpen = !tooltip.hidden;

      /* Close all open tooltips in this wrap first */
      closeAllInWrap(btn.closest('.mstl-image-wrap'));

      if (isOpen) return; /* toggle off */

      openTooltip(btn, tooltip);
    });
  });

  /* ── Close button inside tooltip ────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mstl-tooltip__close')) {
      var tooltip = e.target.closest('.mstl-tooltip');
      if (tooltip) closeTooltip(tooltip);
    }
  });

  /* ── Click outside → close ──────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.mstl-hotspot') && !e.target.closest('.mstl-tooltip')) {
      document.querySelectorAll('.mstl-tooltip.is-open').forEach(closeTooltip);
    }
  });

  /* ── Escape key → close ─────────────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.mstl-tooltip.is-open').forEach(closeTooltip);
    }
  });

  /* ════════════════════════════════════════════════════════════════════ */

  function openTooltip(btn, tooltip) {
    tooltip.hidden = false;
    tooltip.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');

    var wrap = btn.closest('.mstl-image-wrap');
    positionTooltip(btn, tooltip, wrap);

    /* Focus the close button for keyboard users */
    var closeBtn = tooltip.querySelector('.mstl-tooltip__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeTooltip(tooltip) {
    tooltip.hidden = true;
    tooltip.classList.remove('is-open');

    /* Reset paired hotspot */
    var id  = tooltip.id.replace('mstl-tip-', '');
    var btn = document.querySelector('[data-hotspot-id="' + id + '"]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAllInWrap(wrap) {
    if (!wrap) return;
    wrap.querySelectorAll('.mstl-tooltip.is-open').forEach(closeTooltip);
  }

  /*
    Smart positioning: tries right of pin → flips left if overflow.
    Then tries below pin vertically → flips up if overflow.
    Always stays at least 8 px from image edges.
  */
  function positionTooltip(btn, tooltip, wrap) {
    var wRect = wrap.getBoundingClientRect();
    var bRect = btn.getBoundingClientRect();

    /* Pin centre relative to wrap */
    var pinX = bRect.left + bRect.width  / 2 - wRect.left;
    var pinY = bRect.top  + bRect.height / 2 - wRect.top;

    /* Measure tooltip (briefly visible at 0,0) */
    tooltip.style.left = '0px';
    tooltip.style.top  = '0px';
    var tw = tooltip.offsetWidth;
    var th = tooltip.offsetHeight;
    var wW = wRect.width;
    var wH = wRect.height;

    /* Horizontal: prefer right */
    var left = pinX + OFFSET + bRect.width / 2;
    if (left + tw > wW - 8) {
      left = pinX - OFFSET - bRect.width / 2 - tw;
    }
    left = Math.max(8, Math.min(left, wW - tw - 8));

    /* Vertical: centre on pin, clamp to wrap */
    var top = pinY - th / 2;
    top = Math.max(8, Math.min(top, wH - th - 8));

    tooltip.style.left = Math.round(left) + 'px';
    tooltip.style.top  = Math.round(top)  + 'px';
  }

}());
